import { reqGet, reqPut } from './index';

export const fetchAlertInfo = param => reqGet('/v3/api/common/alert', param);
export const updateUserAlertInfo = ({ userNum, ...restParam }) =>
    reqPut(`/v3/api/common/alert/config/user/${userNum}`, restParam.alertConfigModifyRequests);
export const fetchNumOfUnreadAlert = param => reqGet('/v3/api/common/alert/count', param);
export const fetchSelectedUserAlertInfo = param => reqGet(`/v3/api/common/alert/config/user/${param.userNum}`);
